import { denormalize, normalize, schema } from 'normalizr'

import requestStatuses from '@cinch/oxd-utils/request-status/src'

import * as types from '../types'

export const initialState = {
  fetchStatus: requestStatuses.INITIAL,
  byId: {},
  allIds: [],
}

const idAttribute = 'vehicleId'
const favourites = new schema.Entity('directFavourites', undefined, { idAttribute })
const responseSchema = new schema.Array(favourites)

function normaliseFavourites(favouriteVehicles: Cinch.DirectFavouriteVehicle[]) {
  const { entities } = normalize(favouriteVehicles, responseSchema)

  const byId = entities && entities.directFavourites ? entities.directFavourites : {}
  const allIds = favouriteVehicles.map((fave) => fave[idAttribute])

  return {
    allIds,
    byId,
  }
}

function removeFavourite(state: any, id: string) {
  const denorm = denormalize(state.allIds, responseSchema, { directFavourites: state.byId })

  return normaliseFavourites(denorm.filter((fave: any) => fave[idAttribute] !== id))
}

function removeFavourites(state: any, ids: string[]) {
  const denorm = denormalize(state.allIds, responseSchema, { directFavourites: state.byId })

  return normaliseFavourites(denorm.filter((fave: any) => !ids.includes(fave[idAttribute])))
}

export default function reducer(state = initialState, action: any) {
  const { type, payload } = action

  switch (type) {
    case types.GET_DIRECT_FAVOURITES_REQUEST:
      return {
        ...state,
        byId: {},
        allIds: [],
        fetchStatus: requestStatuses.PENDING,
      }
    case types.GET_DIRECT_FAVOURITES_SUCCESS: {
      return {
        ...state,
        fetchStatus: requestStatuses.SUCCESS,
        ...normaliseFavourites(payload.favouriteVehicles.reverse()),
      }
    }
    case types.GET_DIRECT_FAVOURITES_FAILURE:
      return {
        ...state,
        fetchStatus: requestStatuses.ERROR,
      }
    case types.ADD_DIRECT_FAVOURITE_SUCCESS: {
      return {
        ...state,
        ...normaliseFavourites([payload, ...state.allIds.map((id) => ({ ...(state.byId[id] as object) }))]),
      }
    }
    case types.REMOVE_DIRECT_FAVOURITE_SUCCESS: {
      return {
        ...state,
        ...removeFavourite(state, payload.vehicleId),
      }
    }
    case types.REMOVE_DIRECT_FAVOURITES_SUCCESS: {
      return {
        ...state,
        ...removeFavourites(state, payload.vehicles),
      }
    }
    default:
      return state
  }
}
